/**
 * Silent error logger for API mutations
 * Use this when you want to log errors without showing user notifications
 */
export function handleMutationError(err: unknown, context?: string) {
  // Handle axios/HTTP errors with response
  if (
    err &&
    typeof err === "object" &&
    "response" in err &&
    err.response &&
    typeof err.response === "object" &&
    "status" in err.response
  ) {
    console.error(
      `${context || "Operation"} failed with status ${err.response.status}:`,
      err,
    );
  } else {
    // Network error or other non-HTTP error
    console.error(`${context || "Operation"} failed:`, err);
  }
}

/**
 * Silently logs errors without showing toast (for operations that handle errors themselves)
 */
export function logMutationError(err: unknown, context?: string) {
  if (
    err &&
    typeof err === "object" &&
    "response" in err &&
    err.response &&
    typeof err.response === "object" &&
    "status" in err.response
  ) {
    console.error(
      `${context || "Operation"} failed with status ${err.response.status}:`,
      err,
    );
  } else {
    console.error(`${context || "Operation"} failed:`, err);
  }
}

/**
 * Check if error is a specific HTTP status code
 */
export function isHttpError(err: unknown, status: number): boolean {
  return !!(
    err &&
    typeof err === "object" &&
    "response" in err &&
    err.response &&
    typeof err.response === "object" &&
    "status" in err.response &&
    err.response.status === status
  );
}

/**
 * Check if error is a network error (no response)
 */
export function isNetworkError(err: unknown): boolean {
  return !!(
    err &&
    typeof err === "object" &&
    !("response" in err) &&
    ("message" in err || "code" in err)
  );
}

export function getApiErrorMessage(err: unknown, fallback: string): string {
  if (
    err &&
    typeof err === "object" &&
    "response" in err &&
    err.response &&
    typeof err.response === "object" &&
    "data" in err.response &&
    err.response.data &&
    typeof err.response.data === "object" &&
    "message" in err.response.data &&
    typeof err.response.data.message === "string"
  ) {
    return err.response.data.message;
  }
  if (err instanceof Error) {
    return err.message;
  }
  return fallback;
}
